// extracted by mini-css-extract-plugin
export default {"content":"ExpectPage_content__m5OFj","img":"ExpectPage_img__tLS4j","text":"ExpectPage_text__MZA-8"};